export const removeMentionExtensionTags = (text: string) => {
    let newText = text;

    newText = newText.replaceAll(/<span data-type="mention"[^<]+>\[([^\]]+)\]<\/span>/g, '[$1]');

    return newText;
};
